module.exports = {
  configuration: {
    data: {
      bonusConfig: {
        comboBonus: true,
        comboAccumulationBonus: true,
        timerBonus: true,
      },
      designConfig: {
        background:
          "https://bogart-april-storage.omn.proximis.com/Imagestorage/imagesSynchro/600/600/7c5b9e439f083c1119cf6cf962d4d2c80286cf5b_9aed4f22-5dae-44de-a208-front.jpeg",
      },
      questions: [
        {
          image_type: "background",
          image:
            "https://www.incenza.com/img/contentpage/b513c_image_original.jpg",
          text: "What are the 5 main inspirations of the designer Narciso Rodriguez ?",
          timer: 30,
          answers: [
            {
              id: "",
              type: "text",
              answer: "New York city",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "Art",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "Women",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "Fashion codes",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "Architecture",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "Cuba",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Nature",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Design",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Men",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "New technologies",
              isTrue: false,
            },
          ],
        },
        {
          image_type: "cover",
          image:
            "https://1.bp.blogspot.com/-jSSJsDUXdm4/YALfqKGJo0I/AAAAAAAAVmQ/hJLDdFUTR5oc_uQjS4VX9IlzkOFzXI-NACLcBGAsYHQ/s998/.jpg",
          text: "What is the Narciso Rodriguez olfactory signature ?",
          timer: 30,
          answers: [
            {
              id: "",
              type: "text",
              answer: "Floral notes",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "Heart of musc",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "Woody notes",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "Aquatic notes",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Fruity notes",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Gourmand notes",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Leither notes",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Amber notes",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Oud notes",
              isTrue: false,
            },
          ],
        },
        {
          image_type: null,
          image: null,
          text: "Which are the right bottle and pack of for her eau de toilette fragrance?",
          timer: 30,
          answers: [
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Narciso_Bottles_Boxes/For_Her-Eau_de_parfum_Bottle.png",
              isTrue: true,
            },
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Narciso_Bottles_Boxes/For_Her-Eau_de_toilette_Box.png",
              isTrue: true,
            },
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Narciso_Bottles_Boxes/Pure_Musc_For_Her_Bottle.png",
              isTrue: false,
            },
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Narciso_Bottles_Boxes/Musc_Noir-For_Her_Bottle.png",
              isTrue: false,
            },
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Narciso_Bottles_Boxes/For_Her-Eau_de_toilette_Bottlepng.png",
              isTrue: false,
            },
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Narciso_Bottles_Boxes/For_Her-Eau_de_parfum_Box.png",
              isTrue: false,
            },
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Narciso_Bottles_Boxes/Pure_Musc_For_Her_Box.png",
              isTrue: false,
            },
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Narciso_Bottles_Boxes/Musc_Noir-For_Her_Box.png",
              isTrue: false,
            },
          ],
        },
        {
          image_type: null,
          image: null,
          text: "for her story : What ingredient inspires the original scent of for her ?",
          timer: 30,
          answers: [
            {
              id: "",
              type: "text",
              answer: "Egyptian musc",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "White Lily",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Orange blossom",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Jasmine",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Tuberose",
              isTrue: false,
            },
          ],
        },
        {
          image_type: null,
          image: null,
          text: "What is for her eau de toilette fragrance composition ?",
          timer: 30,
          answers: [
            {
              id: "",
              type: "text",
              answer: "Osmanthus",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "Heart of musc",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "Amber woods",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "Vanilla",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Lily of the Valley",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Lemon",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Peony",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Patchouli",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Gardenia",
              isTrue: false,
            },
          ],
        },
        {
          image_type: null,
          image: null,
          text: "What is for her eau de parfum fragrance composition ?",
          timer: 30,
          answers: [
            {
              id: "",
              type: "text",
              answer: "Rose & Peach",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "Heart of musc",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "Patchouli & Amber",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "Lavender",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Jasmine",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Sandalwood",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Tuberose",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Cedarwood",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "Gardenia",
              isTrue: false,
            },
          ],
        },
        {
          image_type: null,
          image: null,
          text: "What is the particularity of for her pure musc variation ?",
          timer: 30,
          answers: [
            {
              id: "",
              type: "text",
              answer: "It can be used on its own",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "It can be combined with any for her variations",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "It is a fragrance booster",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "It is overdosed of heart of musc",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "It enhances the other fragrance key ingredient",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "It is a limited edition",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "It can be combined with any NARCISO variations",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "It can’t be used on its own",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "It is a masculine fragrance",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "It is a hair mist",
              isTrue: false,
            },
          ],
        },
        {
          image_type: null,
          image: null,
          text: "What is fragrance composition of L’Eau d’Issey Eau de Toilette?",
          timer: 30,
          answers: [
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Issey_Miyake_ingredients%20/Precious_wood_text.png",
              isTrue: true,
            },
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Issey_Miyake_ingredients%20/Cinnamon_text.png",
              isTrue: false,
            },
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Issey_Miyake_ingredients%20/Bergamot_text.png",
              isTrue: false,
            },
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Issey_Miyake_ingredients%20/Aquatic_Lilac_text.png",
              isTrue: false,
            },
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Issey_Miyake_ingredients%20/Rose_Lotus_text.png",
              isTrue: true,
            },
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Issey_Miyake_ingredients%20/Yuzu_text.png",
              isTrue: false,
            },
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Issey_Miyake_ingredients%20/Yellow_Freesia_text.png",
              isTrue: false,
            },
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Issey_Miyake_ingredients%20/White_flowers_text.png",
              isTrue: true,
            },
            {
              id: "",
              type: "image",
              answer:
                "https://mediastoresopi.blob.core.windows.net/shiseido-upload/Issey_Miyake_ingredients%20/Sandalwood.png",
              isTrue: false,
            },
          ],
        },
        {
          image_type: null,
          image: null,
          text: "What are the words to describe the for her musc noir rose fragrance ?",
          timer: 30,
          answers: [
            {
              id: "",
              type: "text",
              answer: "FLORAL",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "AMBERY",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "INTIMATE",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "ENVELOPING",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "BERGAMOTE",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "TUBEROSE",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "HEART OF MUSC",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "VANILLA",
              isTrue: true,
            },
            {
              id: "",
              type: "text",
              answer: "SPARKLING",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "DELICATE",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "ORANGEL BLOSSOM",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "PATCHOULI",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "SENSUAL",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "SOPHISTICATED",
              isTrue: false,
            },
            {
              id: "",
              type: "text",
              answer: "ELEGANT",
              isTrue: false,
            },
          ],
        },
      ],
    },
  },
  results: {
    372: {
      score: [1, 1, 1],
      position: 3,
      // total: 15,
      // position: 1,
    },
    373: {
      score: [2, 1, 3],
      position: 3,
      // total: 0,
      // position: 1,
    },
    374: {
      score: [1, 1, 3],
      position: 3,
      // total: 10,
      // position: 1,
    },
    375: {
      score: [3, 2, 1],
      position: 3,
      // total: 29,
      // position: 1,
    },
    376: {
      score: [1, 3, 3],
      position: 3,
      // total: 29,
      // position: 1,
    },
    399: {
      score: [2, 3],
      position: 3,
    },
  },
};
